import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { NS } from '@/constants';

import { useScreenSizeContext } from '@/components/ScreenSize.context';

import styles from './ProductRating.module.scss';
import { URLS } from '@/constants/urls';

export const ProductRating = ({ topRating, ratingsCount, scrollToRatings }) => {
  const { name, value, ratingMax } = topRating;
  const { t } = useTranslation();
  const { isDesktop } = useScreenSizeContext();

  return (
    <div className={styles.container} data-test-id="product-rating">
      <img src={URLS.STAR_YELLOW} width={16} height={16} alt={t('yellowStar', { ns: NS.ALTER })} className={styles.icon}/>
      <div className={styles.content}>
        <div className={styles.note} data-test-id="note">
          <span>{name}</span>
          <span className={styles.separator}/>
          <span>{`${value}/${ratingMax}`}</span>
        </div>
      </div>
      {isDesktop && ratingsCount > 0 &&
        <div data-test-id="see-ratings" className={styles['see-ratings']} onClick={scrollToRatings}>
          {`+${ratingsCount} ${t('product.ratings')}`}
        </div>
      }
    </div>
  );
};

ProductRating.propTypes = {
  ratingsCount: PropTypes.number,
  topRating: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    ratingMax: PropTypes.string
  }),
  scrollToRatings: PropTypes.func
};

export default ProductRating;
